import React, { useState } from "react";
import { OnboardingBg } from "../../resources/js/images";

import { useHistory } from "react-router-dom";
import { LOGIN } from "../../constants/routes";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import Hero from "../contactUs/Hero";
import HeroDetails from "./heroDetails";
import WelcomePage from "./WelcomePage";
const Onboarding = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const history = useHistory();
    return (
        <div className="bg-blue-700 sm:bg-transparent">
            <Hero
                content={<HeroDetails />}
                url={OnboardingBg}
                wrapperClass={"min-h-[70vh] hidden sm:block"}
                containerClass={" mb-0 sm:mb-0 xl:mb-0 2xl:mb-0 lg:mb-0"}
            />
            <div className="sm:hidden pt-[10rem]">
                {currentTab === 1 ? (
                    <HeroDetails />
                ) : (
                    <div className="bg-white p-1 rounded-t-2.5">
                        <WelcomePage />
                        <Button
                            className={
                                "bg-black text-white mt-3  xs:text-base xs:mt-5 !rounded-[3rem] w-full"
                            }
                            onClick={() => setCurrentTab((prev) => prev + 1)}
                        >
                            Onboarding
                        </Button>
                        <div className="flex items-center justify-end mb-5">
                            <P className="flex items-center gap-0.2">
                                Already have account?
                                <span
                                    className="text-blue underline"
                                    role="button"
                                    onClick={() => history.push(LOGIN)}
                                >
                                    Sign in
                                </span>
                            </P>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Onboarding;
